(function () {
  var sections = document.querySelectorAll('.oddit-section-main-product');
  if (!sections.length) return;

  sections.forEach(function (section) {
    initVariantSelector(section);
    initVariantSwitching(section);
    initGallery(section);
    initThumbnailDrag(section);
    initStickyCta(section);
    initDescriptionToggle(section);
    initQuantitySelector(section);
  });

  function formatAmount(cents, precision, thousands, decimal) {
    var amount = (Number(cents) / 100).toFixed(precision);
    var parts = amount.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    var token = match ? match[1] : 'amount';
    var decimal = '.';
    var value;

    switch (token) {
      case 'amount_no_decimals':
        value = formatAmount(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        decimal = ',';
        value = formatAmount(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatAmount(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatAmount(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        decimal = ',';
        value = formatAmount(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatAmount(cents, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatAmount(cents, 2, ' ', '.');
        break;
      default:
        value = formatAmount(cents, 2, ',', '.');
    }

    value = value.replace(new RegExp('\\' + decimal + '0+$'), '');

    return format.replace(placeholder, value);
  }

  function readVariantData(section) {
    var dataEl = section.querySelector('[data-product-variants]');
    if (!dataEl) return { variants: [], moneyFormat: '' };

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      variants = [];
    }

    return {
      variants: variants,
      moneyFormat: dataEl.getAttribute('data-money-format') || ''
    };
  }

  function variantPriceLabel(variant, quantity, moneyFormat) {
    if (quantity <= 1 || typeof variant.price_cents !== 'number') return variant.price;
    return formatMoney(variant.price_cents * quantity, moneyFormat);
  }

  function readQuantity(section) {
    var input =
      section.querySelector('[data-quantity-input]') ||
      document.querySelector('[data-buy-buttons] [data-quantity-input]');
    if (!input) return 1;

    var parsed = parseInt(input.value, 10);
    return isNaN(parsed) || parsed < 1 ? 1 : parsed;
  }

  function onQuantityChange(section, handler) {
    var input =
      section.querySelector('[data-quantity-input]') ||
      document.querySelector('[data-buy-buttons] [data-quantity-input]');
    if (!input) return;

    input.addEventListener('change', handler);
    input.addEventListener('input', handler);
  }

  function initQuantitySelector(section) {
    var selector = section.querySelector('[data-quantity-selector]');
    if (!selector) return;

    var input = selector.querySelector('[data-quantity-input]');
    if (!input) return;

    var decrease = selector.querySelector('[data-quantity-decrease]');
    var increase = selector.querySelector('[data-quantity-increase]');
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min) || min < 1) min = 1;

    function readValue() {
      var parsed = parseInt(input.value, 10);
      return isNaN(parsed) ? min : parsed;
    }

    function setValue(next) {
      if (next < min) next = min;
      var changed = String(input.value) !== String(next);
      input.value = next;
      if (decrease) decrease.disabled = next <= min;
      if (changed) input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (decrease) {
      decrease.addEventListener('click', function () {
        setValue(readValue() - 1);
      });
    }

    if (increase) {
      increase.addEventListener('click', function () {
        setValue(readValue() + 1);
      });
    }

    input.addEventListener('change', function () {
      setValue(readValue());
    });

    input.addEventListener('blur', function () {
      setValue(readValue());
    });

    setValue(readValue());
  }

  function initDescriptionToggle(section) {
    var wrap = section.querySelector('[data-product-description]');
    if (!wrap) return;

    var text = wrap.querySelector('[data-product-description-text]');
    var toggle = wrap.querySelector('[data-product-description-toggle]');
    if (!text || !toggle) return;

    var CLAMPED = 'oddit-section-main-product__description--clamped';
    var labelMore = toggle.getAttribute('data-label-more') || 'Show more';
    var labelLess = toggle.getAttribute('data-label-less') || 'Show less';

    function overflows() {
      return text.scrollHeight > text.clientHeight + 1;
    }

    function syncToggle() {
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      toggle.hidden = !overflows();
    }

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var next = !expanded;
      toggle.setAttribute('aria-expanded', String(next));
      text.classList.toggle(CLAMPED, !next);
      toggle.textContent = next ? labelLess : labelMore;
    });

    syncToggle();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncToggle, 150);
    });

    if (document.fonts && typeof document.fonts.ready === 'object') {
      document.fonts.ready.then(syncToggle).catch(function () {});
    }
  }

  /**
   * Variant switching — when a variant input changes, update the add-to-cart
   * button (target variant id, price in label, availability) and keep the
   * Shop Pay installments banner in sync with the selected variant.
   */
  function initVariantSwitching(section) {
    var form = section.querySelector('[data-variant-form]');
    var addButton = section.querySelector('[data-add-to-cart]');
    if (!addButton) return;

    var variantData = readVariantData(section);
    var variants = variantData.variants;
    if (!variants.length) return;

    var labelEl = addButton.querySelector('[data-button-label]');
    var baseLabel = addButton.getAttribute('data-base-label') || 'Add to Cart';
    var soldOutLabel = addButton.getAttribute('data-sold-out-label') || 'Sold out';
    var showPrice = addButton.getAttribute('data-show-price') === 'true';

    var paymentTerms = section.querySelector('shopify-payment-terms');
    var paymentForm = paymentTerms ? paymentTerms.closest('form') : null;
    var paymentInput = paymentForm
      ? paymentForm.querySelector('input[name="id"]')
      : null;
    var productFormInput = section.querySelector('[data-product-variant-id]');

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    var currentVariant = findVariant(addButton.getAttribute('data-variant-id'));

    function renderLabel() {
      if (!currentVariant) return;

      if (currentVariant.available) {
        addButton.disabled = false;
        if (labelEl) {
          labelEl.textContent = showPrice
            ? baseLabel +
              ' · ' +
              variantPriceLabel(currentVariant, readQuantity(section), variantData.moneyFormat)
            : baseLabel;
        }
      } else {
        addButton.disabled = true;
        if (labelEl) labelEl.textContent = soldOutLabel;
      }
    }

    function selectVariant(id) {
      var variant = findVariant(id);
      if (!variant) return;

      currentVariant = variant;
      addButton.setAttribute('data-variant-id', variant.id);
      renderLabel();

      if (productFormInput && String(productFormInput.value) !== String(variant.id)) {
        productFormInput.value = variant.id;
        productFormInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Keep the Shop Pay installments banner pointed at the selected variant.
      if (paymentInput) paymentInput.value = variant.id;
      if (paymentTerms) paymentTerms.setAttribute('variant-id', variant.id);
    }

    if (form) {
      form.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.addEventListener('change', function () {
          selectVariant(input.value);
        });
      });
    }

    onQuantityChange(section, renderLabel);
  }

  /**
   * Variant selector — toggle selected state when a variant radio is changed.
   * Updates the visual ring + background and reflects in the radio visual.
   */
  function initVariantSelector(section) {
    var form = section.querySelector('[data-variant-form]');
    if (!form) return;

    var variants = form.querySelectorAll('.oddit-section-main-product__variant');
    var radios = form.querySelectorAll('input[type="radio"][name="id"]');

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        variants.forEach(function (variant) {
          var radioEl = variant.querySelector('input[type="radio"]');
          var visual = variant.querySelector('.oddit-section-main-product__variant-radio-visual');
          if (!radioEl || !visual) return;

          if (radioEl.checked) {
            variant.classList.add('oddit-section-main-product__variant--selected');
            visual.classList.add('oddit-section-main-product__variant-radio-visual--selected');
            visual.innerHTML =
              '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<circle cx="12" cy="12" r="11" stroke="#272727" stroke-width="2" fill="#f9f7f1"/>' +
              '<circle cx="12" cy="12" r="8" fill="#de4726"/>' +
              '</svg>';
          } else {
            variant.classList.remove('oddit-section-main-product__variant--selected');
            visual.classList.remove('oddit-section-main-product__variant-radio-visual--selected');
            visual.innerHTML =
              '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<circle cx="12" cy="12" r="11" stroke="#272727" stroke-width="2" fill="#f9f7f1"/>' +
              '</svg>';
          }
        });
      });
    });
  }

  /**
   * Gallery — the main image is a horizontal scroll-snap slider. Swiping (or
   * scrolling) it keeps the matching thumbnail active; clicking a thumbnail or
   * using the prev/next arrows scrolls the slider to that slide. The active
   * thumbnail is kept in view in its rail as the slide changes.
   */
  function initGallery(section) {
    var slider = section.querySelector('[data-gallery-slider]');
    var slides = slider
      ? Array.prototype.slice.call(slider.querySelectorAll('[data-gallery-slide]'))
      : [];
    var thumbs = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-main-product__thumbnail')
    );
    if (!slider || slides.length < 2) return;

    var ACTIVE = 'oddit-section-main-product__thumbnail--active';
    var current = 0;

    // Scroll offset of a slide relative to the first one — padding-agnostic, so
    // it stays correct across the mobile/tablet bleed and the desktop reset.
    function slideOffset(index) {
      return slides[index].offsetLeft - slides[0].offsetLeft;
    }

    function setActive(index) {
      if (index < 0) index = 0;
      if (index >= slides.length) index = slides.length - 1;
      if (index === current) return;
      current = index;

      thumbs.forEach(function (t, i) {
        t.classList.toggle(ACTIVE, i === index);
      });

      var activeThumb = thumbs[index];
      if (activeThumb) {
        activeThumb.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    }

    function goTo(index, smooth) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slider.scrollTo({
        left: slideOffset(index),
        behavior: smooth ? 'smooth' : 'auto',
      });
      setActive(index);
    }

    function currentFromScroll() {
      var pos = slider.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var dist = Math.abs(slideOffset(i) - pos);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    var rafId = null;
    slider.addEventListener('scroll', function () {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        setActive(currentFromScroll());
      });
    });

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        goTo(index, true);
      });
    });

    var prev = section.querySelector('[data-gallery-prev]');
    var next = section.querySelector('[data-gallery-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        goTo(current - 1, true);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(current + 1, true);
      });
    }
  }

  /**
   * Thumbnail drag — pointer-based click-and-drag scrolling for the
   * thumbnail rail so it works like a swiper on desktop (touch devices
   * already scroll natively). A drag past a small threshold suppresses
   * the thumbnail click so dragging never swaps the main image.
   */
  function initThumbnailDrag(section) {
    var rail = section.querySelector('.oddit-section-main-product__thumbnails');
    if (!rail) return;

    var DRAG_CLASS = 'oddit-section-main-product__thumbnails--dragging';
    var THRESHOLD = 4;
    var isDown = false;
    var dragged = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;

    rail.addEventListener('pointerdown', function (e) {
      // Only respond to primary mouse / pen input; touch scrolls natively.
      if (e.pointerType === 'touch') return;
      isDown = true;
      dragged = false;
      startX = e.clientX;
      startScroll = rail.scrollLeft;
      pointerId = e.pointerId;
    });

    rail.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.clientX - startX;
      if (!dragged && Math.abs(delta) > THRESHOLD) {
        dragged = true;
        rail.classList.add(DRAG_CLASS);
        if (pointerId !== null && rail.setPointerCapture) {
          rail.setPointerCapture(pointerId);
        }
      }
      if (dragged) {
        e.preventDefault();
        rail.scrollLeft = startScroll - delta;
      }
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      if (dragged) {
        rail.classList.remove(DRAG_CLASS);
        if (pointerId !== null && rail.releasePointerCapture) {
          try {
            rail.releasePointerCapture(pointerId);
          } catch (err) {}
        }
      }
      pointerId = null;
    }

    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener('pointerleave', endDrag);

    // Block the click that fires after a drag so the main image isn't swapped.
    rail.addEventListener(
      'click',
      function (e) {
        if (dragged) {
          e.stopPropagation();
          e.preventDefault();
          dragged = false;
        }
      },
      true
    );
  }

  /**
   * Sticky add-to-cart bar — rendered as a sibling of this section (position:
   * fixed). Two jobs: keep its button in sync with the selected variant, and
   * reveal it on scroll. It is hidden until the shopper scrolls past the main
   * add-to-cart, then hides again once the footer comes into view so it never
   * covers footer content. Reveal uses IntersectionObservers (no scroll
   * handler) and, when the sentinels or IO are unavailable, the bar simply
   * stays in its default always-visible state.
   */
  function initStickyCta(section) {
    var parent = section.parentNode;
    var bar = parent ? parent.querySelector('[data-sticky-cta]') : null;
    if (!bar) return;

    syncStickyVariant(section, bar);
    revealStickyOnScroll(section, bar);
  }

  function syncStickyVariant(section, bar) {
    var form = section.querySelector('[data-variant-form]');
    var button = bar.querySelector('[data-add-to-cart][data-variant-id]');
    if (!button) return;

    var variantData = readVariantData(section);
    var variants = variantData.variants;
    if (!variants.length) return;

    var labelEl = button.querySelector('[data-button-label]');
    var baseLabel = button.getAttribute('data-base-label') || 'Add';
    var soldOutLabel = button.getAttribute('data-sold-out-label') || 'Sold out';

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    var currentVariant = findVariant(button.getAttribute('data-variant-id'));

    function renderLabel() {
      if (!currentVariant) return;

      if (currentVariant.available) {
        var priceLabel = variantPriceLabel(
          currentVariant,
          readQuantity(section),
          variantData.moneyFormat
        );
        button.disabled = false;
        if (labelEl) labelEl.textContent = baseLabel + ' · ' + priceLabel;
        button.setAttribute('aria-label', baseLabel + ' to cart for ' + priceLabel);
      } else {
        button.disabled = true;
        if (labelEl) labelEl.textContent = soldOutLabel;
        button.setAttribute('aria-label', soldOutLabel);
      }
    }

    function selectVariant(id) {
      var variant = findVariant(id);
      if (!variant) return;

      currentVariant = variant;
      button.setAttribute('data-variant-id', variant.id);
      renderLabel();
    }

    if (form) {
      form.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.addEventListener('change', function () {
          selectVariant(input.value);
        });
      });
    }

    onQuantityChange(section, renderLabel);
  }

  function revealStickyOnScroll(section, bar) {
    if (typeof IntersectionObserver === 'undefined') return;

    var atcAnchor =
      section.querySelector('[data-buy-buttons]') ||
      section.querySelector('[data-add-to-cart]');
    if (!atcAnchor) return;

    var mainContent = document.getElementById('MainContent');
    var footerAnchor =
      (mainContent && mainContent.nextElementSibling) ||
      document.querySelector('.oddit-footer-main') ||
      document.querySelector('footer');

    // Opt into scroll-driven mode — this is what hides the bar by default, so a
    // page without JS keeps the bar permanently visible.
    bar.classList.add('oddit-section-sticky-cta--scroll-driven');

    var pastAtc = false;
    var footerReached = false;

    function update() {
      bar.classList.toggle(
        'oddit-section-sticky-cta--visible',
        pastAtc && !footerReached
      );
    }

    // Reveal once the main ATC has scrolled above the top of the viewport.
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      pastAtc = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(atcAnchor);

    // Hide again once the footer's top has entered the viewport, and keep it
    // hidden for the rest of the footer. Using isIntersecting here would flip
    // back to false (and re-show the bar) once the first footer section scrolls
    // off the top, so test the top edge's position instead.
    if (footerAnchor) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var viewportHeight =
          (entry.rootBounds && entry.rootBounds.height) || window.innerHeight;
        footerReached = entry.boundingClientRect.top < viewportHeight;
        update();
      }).observe(footerAnchor);
    }
  }
})();
